import { useTranslation } from 'react-i18next';

export const useAgreedExtensionStatsLabels = (): Record<string, string> => {
  const { t } = useTranslation('agreed_extension_stats_annual_dfi_report');

  const agreedExtensionStatsLabels: Record<string, string> = {
    totalStatutoryConsultationsWithExtensionsTimeframe: t(
      'total_statutory_consultations_with_extensions_timeframe',
      'Total number of statutory consultations with agreed extensions of timeframe'
    ),
    totalStatutoryConsultationResponsesWithinExtensionTimeframe: t(
      'total_statutory_consultation_responses_within_extension_timeframe',
      'Total number of statutory consultation responses returned within an agreed extension timeframe'
    ),
    totalStatutoryConsultationsWithExtensionsTimeframeExtended1To7Days: t(
      'total_statutory_consultations_with_extensions_timeframe_extended_1_to_7_days',
      'Total number of statutory consultations with agreed extensions of timeframe extended by 1-7 days'
    ),
    percentageStatutoryConsultationsWithExtensionsTimeframeExtended1To7Days: t(
      'percentage_statutory_consultations_with_extensions_timeframe_extended_1_to_7_days',
      'Percentage of statutory consultations with agreed extensions of timeframe extended by 1-7 days'
    ),
    totalStatutoryConsultationsWithExtensionsTimeframeExtended8To14Days: t(
      'total_statutory_consultations_with_extensions_timeframe_extended_8_to_14_days',
      'Total number of statutory consultations with agreed extensions of timeframe extended by 8-14 days'
    ),
    percentageStatutoryConsultationsWithExtensionsTimeframeExtended8To14Days: t(
      'percentage_statutory_consultations_with_extensions_timeframe_extended_8_to_14_days',
      'Percentage of statutory consultations with agreed extensions of timeframe extended by 8-14 days'
    ),
    totalStatutoryConsultationsWithExtensionsTimeframeExtended15To21Days: t(
      'total_statutory_consultations_with_extensions_timeframe_extended_15_to_21_days',
      'Total number of statutory consultations with agreed extensions of timeframe extended by 15-21 days'
    ),
    percentageStatutoryConsultationsWithExtensionsTimeframeExtended15To21Days: t(
      'percentage_statutory_consultations_with_extensions_timeframe_extended_15_to_21_days',
      'Percentage of statutory consultations with agreed extensions of timeframe extended by 15-21 days'
    ),
    totalStatutoryConsultationsWithExtensionsTimeframeExtended22To28Days: t(
      'total_statutory_consultations_with_extensions_timeframe_extended_22_to_28_days',
      'Total number of statutory consultations with agreed extensions of timeframe extended by 22-28 days'
    ),
    percentageConsultationsWithExtensionsTimeframeExtended22To28Days: t(
      'percentage_consultations_with_extensions_timeframe_extended_22_to_28_days',
      'Percentage of statutory consultations with agreed extensions of timeframe extended by 22-28 days'
    ),
    totalStatutoryConsultationsWithExtensionsTimeframeExtended29PlusDays: t(
      'total_statutory_consultations_with_extensions_timeframe_extended_29_plus_days',
      'Total number of statutory consultations with agreed extensions of timeframe extended by 29 days and over'
    ),
    percentageStatutoryConsultationsWithExtensionsTimeframeExtended29PlusDays: t(
      'percentage_statutory_consultations_with_extensions_timeframe_extended_29_plus_days',
      'Percentage of statutory consultations with agreed extensions of timeframe extended by 29 days and over'
    ),
  };

  return agreedExtensionStatsLabels;
};
